import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
import { TableColumn } from '../../../dto/util/table-column';
import {
  FiltroParametrizacionDTO,
  ParametrizacionDto,
} from '../../../dto/expediente/parametrizacion.dto';
import { TableAction } from '../../../dto/util/table-action';
import { FormEditarParametrizacionComponent } from '../../forms/form-editar-parametrizacion/form-editar-parametrizacion.component';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-gestion-parametrizacion',
  templateUrl: './gestion-parametrizacion.component.html',
  styleUrl: './gestion-parametrizacion.component.scss',
})
export class GestionParametrizacionComponent implements OnInit {
  @ViewChild(FormEditarParametrizacionComponent)
  formEditarParametrizacion!: FormEditarParametrizacionComponent;
  private parametrizacionService = inject(ParametrizacionService);
  private translate = inject(TranslateService);
  tableText: any = {};
  columnasParametrizacion: TableColumn[] = [];
  accionesParametrizacion: TableAction[] = [];
  parametrizacion: ParametrizacionDto[] = [];
  tamanoPagina = 10;
  totalPaginas = 0;
  paginaActual = 1;
  filtroParametrizacion: FiltroParametrizacionDTO = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: true,
    ordenarPor: 'nombre_parametro',
  };

  constructor(
    private readonly notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.cargarParametrizacion();
    this.initColumnasParametrizacion();
    // Multilenguaje
    this.translate.stream('parametrizacion').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this.initColumnasParametrizacion();
    });
  }

  editarParametrizacion(event: any) {
    if (this.formEditarParametrizacion) {
      this.formEditarParametrizacion.editarParametrizacion(event);
    }
  }

  cargarParametrizacion() {
    this.parametrizacionService
      .getUrlParametrizacion(this.filtroParametrizacion)
      .subscribe({
        next: response => {
          this.parametrizacion = response.data.registros;
          this.totalPaginas = response.data.totalPaginas;
          this.paginaActual = response.data.numeroPagina;
          this.tamanoPagina = response.data.cantidadRegistros;
        },
        error: error => {
          this.notificationService.addNotification('error','Error al cargar los parametros')
        },
      });
  }

  initColumnasParametrizacion() {
    this.columnasParametrizacion = [
      {
        id: 'nombre_parametro',
        field: 'nombre_parametro',
        title: this.tableText['nombre'],
        filterable: false,
        width: '12rem',
      },
      {
        id: 'descripcion',
        field: 'descripcion',
        title: this.tableText['descripcion'],
        filterable: false,
        width: '12rem',
      },
      {
        id: 'valor_parametro',
        field: 'valor_parametro',
        title: this.tableText['valor'],
        filterable: false,
        width: '12rem',
      },
    ];
    this.accionesParametrizacion = [
      {
        type: 'button',
        icon: 'edit',
        title: 'Editar',
        idAccion: '1',
      },
    ];
  }
}
